import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import NavPanel from '../../../Components/NavPanel/NavPanel';
import classes from './EventPage.module.scss';
import vkIconGrey from '../../../images/icon-vk-grey.svg';
import vkIconBlue from '../../../images/icon-vk-blue.svg';
import noPhoto from '../../../images/noPhoto.png';
import { addressesLinkHadle } from '../../../functions/functions';
import { GeneralContext } from '../../../context/generalContext';
import { addressesAPI, eventAPI } from '../../../services/GeneralService';
import NotFound from '../../NotFound/NotFound';
import SkeletonArticle from '../../../Components/Skeleton/SkeletonArticle/SkeletonArticle';

export default function EventPage() {
  const { activeLanguage, subdomain } = useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();

  const location = useLocation();
  const params = useParams();
  const [item, setItem] = useState(null);
  const [recommended, setRecommended] = useState(null);

  const { data: eventData, isLoading, isError } = eventAPI.useFetchOneEventQuery(params.eventName);

  useEffect(() => {
    if (eventData) {
      setItem(eventData);
    }
  }, [eventData]);

  useEffect(() => {
    if (item && item.recommended) {
      setRecommended(
        item.recommended?.map(rec => {
          const tempDiv = document.createElement('div');
          const reg = /(?=<style>)(.*)(?:style>)/gi;
          tempDiv.innerHTML = rec.content.text.replace('<strong>', '').replace(reg, '');

          const tempDivEn = document.createElement('div');
          tempDivEn.innerHTML =
            rec.content.text_en.replace('<strong>', '').replace(reg, '') ||
            rec.content.text.replace('<strong>', '').replace(reg, '');
          if (tempDiv.hasChildNodes())
            return {
              id: rec.id,
              title: rec.title,
              title_en: rec.title_en,
              image: rec.image,
              name: rec.name,
              date: rec.date,
              text: tempDiv.children[0].textContent,
              text_en: tempDivEn.children[0].textContent,
            };
        }),
      );
    }
  }, [item]);

  const [itemAddresses, setItemAddresses] = useState([]);
  const [itemAddressesEn, setItemAddressesEn] = useState([]);
  const [needLoad, setNeedLoad] = useState(false);
  const [paginatedAddresses, setPaginatedAddresses] = useState([]);
  const [paginatedAddressesEn, setPaginatedAddressesEn] = useState([]);
  const [listIsOpen, setListIsOpen] = useState(false);
  useEffect(() => {
    if (item?.placeName) {
      // с помощью .filter исключаем кутузовский в связи с временным закрытием ресторана
      const addresses = item?.placeName
        ?.replaceAll('&nbsp;', ' ')
        .split('; ')
        .filter(el => !el.toLowerCase().includes('кутузовский'));
      const adressesEn =
        item?.placeName_en
          ?.replaceAll('&nbsp;', ' ')
          .split('; ')
          .filter(el => !el.toLowerCase().includes('kutuzovsky')) || addresses;
      setItemAddresses(addresses);
      setItemAddressesEn(adressesEn);
      if (addresses.length > 10) {
        setNeedLoad(true);
      }
      setPaginatedAddresses(addresses.slice(0, 10));
      setPaginatedAddressesEn(adressesEn.slice(0, 10));
    }
  }, [item]);

  const showAdresses = () => {
    setPaginatedAddresses(itemAddresses);
    setPaginatedAddressesEn(itemAddressesEn);
    setListIsOpen(true);
  };
  const hideAdresses = () => {
    setPaginatedAddresses(itemAddresses.slice(0, 10));
    setPaginatedAddressesEn(itemAddressesEn.slice(0, 10));
    setListIsOpen(false);
  };

  // скролл на начало страницы
  useEffect(() => {
    if (location && item) {
      window.scrollTo(0, 0);
    }
  }, [location, item]);

  // для ссылок адресов
  const [addressesAll, setAddressesAll] = useState([]);
  useEffect(() => {
    let arr = [];
    if (addresses) {
      arr = addressesLinkHadle(addresses);
      setAddressesAll(arr);
    }
  }, [subdomain, addresses]);

  return (
    <>
      {isLoading && <SkeletonArticle />}
      {(item?.title || item?.content) && (
        <div className='wrapper'>
          {item ? (
            <Helmet>
              <title>
                {activeLanguage === 1
                  ? `${item?.title} | Brasserie Lambic`
                  : `${item?.title_en} | Brasserie Lambic` || `${item?.title} | Brasserie Lambic`}
              </title>
            </Helmet>
          ) : (
            <Helmet>
              <title>{activeLanguage === 1 ? 'События | Brasserie Lambic' : 'Events | Brasserie Lambic'}</title>
            </Helmet>
          )}
          {item && (
            <>
              <NavPanel
                name={activeLanguage === 1 ? 'События' : 'Events'}
                link={activeLanguage === 1 ? '/events' : '/en/events'}
                name2={activeLanguage === 1 ? item.title : item.title_en || item.title}
                link2={activeLanguage === 1 ? `/events/${item.name}` : `/en/events/${item.name}`}
              />
              <h1 className={classes.title}>{activeLanguage === 1 ? item.title : item.title_en || item.title}</h1>
              <div className={classes.page}>
                <div className={classes.event}>
                  <LazyLoadImage
                    className={classes.eventImg}
                    src={item.img ? item.img : noPhoto}
                    alt='event illustration'
                  />
                  {item.content &&
                    item.content?.map((contentPart, index) =>
                      contentPart.type === 'заголовок' ? (
                        <div
                          className={classes.eventSubTitle}
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: activeLanguage === 1 ? contentPart.text : contentPart.text_en || contentPart.text,
                          }}
                        />
                      ) : (
                        <p
                          className={classes.eventText}
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: activeLanguage === 1 ? contentPart.text : contentPart.text_en || contentPart.text,
                          }}
                        />
                      ),
                    )}

                  {item.placeName && (
                    <>
                      <div className={classes.addressesTitle}>
                        {activeLanguage === 1 ? 'Доступно в ресторанах' : 'Available in restaurants'}
                      </div>
                      <div className={classes.addresses}>
                        {activeLanguage === 1
                          ? paginatedAddresses.map((address, index) => (
                              <a
                                href={`//${addressesAll.filter(el => el.description === address)[0]?.subdomainLink}`}
                                className={classes.addressLink}
                                key={index}
                                // target="_blank"
                                // rel="noreferrer"
                              >
                                {address}
                              </a>
                            ))
                          : paginatedAddressesEn.map((address, index) => (
                              <a
                                href={`//${addressesAll.filter(el => el.description === address)[0]?.subdomainLink}/en`}
                                className={classes.addressLink}
                                key={index}
                              >
                                {addressesAll.filter(el => el.description === address)[0]?.description_en || address}
                              </a>
                            ))}
                      </div>
                      {needLoad && (
                        <>
                          <div
                            onClick={() => showAdresses()}
                            className={listIsOpen ? classes.disabled : classes.showAddresses}
                          >
                            {activeLanguage === 1 ? 'Показать все адреса' : 'Show all'}
                          </div>
                          <div
                            onClick={() => hideAdresses()}
                            className={listIsOpen ? classes.showAddresses : classes.disabled}
                          >
                            {activeLanguage === 1 ? 'Скрыть адреса' : 'Hide'}
                          </div>
                        </>
                      )}
                    </>
                  )}

                  <div className={classes.eventInfo}>
                    <div className={classes.eventInfoItem}>
                      {activeLanguage === 1 ? 'Опубликовано: ' : 'Published on '}
                      {activeLanguage === 1
                        ? new Date(item.date).toLocaleString('ru', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                          })
                        : new Date(item.date).toLocaleString('en', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                          })}
                    </div>
                    <a
                      className={`${classes.eventInfoItem} ${classes.eventInfoItemVk}`}
                      href={`https://vk.com/share.php?url=${window.location.href}`}
                      rel='noreferrer'
                      target='_blank'
                    >
                      <div className={classes.eventVkText}>
                        {activeLanguage === 1 ? 'Рассказать друзьям' : 'Tell friends'}
                      </div>
                      <img className={classes.eventVkImgGrey} src={vkIconGrey} alt='vk icon' />
                      <img className={classes.eventVkImgBlue} src={vkIconBlue} alt='vk icon' />
                    </a>
                  </div>
                </div>
                <div className={classes.also}>
                  <div className={classes.alsotitle}>{activeLanguage === 1 ? 'Рекомендуем' : 'Recommended'}</div>
                  {recommended &&
                    recommended.map(rec => (
                      <React.Fragment key={rec.id}>
                        <Link
                          to={activeLanguage === 1 ? `/events/${rec.name}` : `/en/events/${rec.name}`}
                          onClick={() => setNeedLoad(false)}
                        >
                          <div className={classes.card}>
                            <LazyLoadImage
                              className={classes.cardImg}
                              src={rec.image ? rec.image : noPhoto}
                              alt='event illustration'
                            />
                            <div className={classes.cardDescription}>
                              <div className={classes.cardTitle}>
                                {activeLanguage === 1 ? rec.title : rec.title_en || rec.title}
                              </div>
                              <div
                                className={classes.cardText}
                                dangerouslySetInnerHTML={{
                                  __html: activeLanguage === 1 ? rec.text : rec.text_en || rec.text,
                                }}
                              />
                              <div className={classes.cardDate}>
                                {activeLanguage === 1
                                  ? new Date(rec.date)
                                      .toLocaleString('ru', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                      })
                                      .slice(0, -3)
                                  : new Date(rec.date).toLocaleString('en', {
                                      year: 'numeric',
                                      month: 'long',
                                      day: 'numeric',
                                    })}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {!(item?.title || item?.content || isLoading) && <NotFound />}
      {isError && <NotFound />}
    </>
  );
}
